import useTranslation from 'next-translate/useTranslation';
import React, { ReactNode } from 'react';

import foodImage from '@/assets/images/empty.png';
import Button from '@/components/common/Button';

import { twMerge } from 'tailwind-merge';

type Props = Partial<{
  image: string;
  className: string;
  children: string | ReactNode | ReactNode[];
  mainDesc: string;
  subDesc: string;
  subDescStyle: string;
  buttonLink: string;
  buttonText: string;
  bundleUrl: string;
  btnStyle: string;
  imageNode: ReactNode;
  imgClassName?: string;
  testId?: string;
}>;

const DefaultChildren = (props: Props) => {
  const { t } = useTranslation('common');

  const { mainDesc, subDesc, buttonLink, buttonText, bundleUrl, subDescStyle, btnStyle } = props;
  return (
    <div className="flex flex-col items-center">
      <div className="enki-heading-xl text-surface-200-fg-default mb-4 w-56 text-center">
        {mainDesc || t('comingsoon')}
      </div>
      <div className={twMerge('enki-body-sm-strong text-surface-100-fg-minor mb-8 w-68 text-center', subDescStyle)}>
        {subDesc || t('empty_desc')}
      </div>
      <Button
        style={{ maxWidth: 'calc(100vw - 48px)' }}
        className={twMerge('w-80', btnStyle)}
        href={buttonLink || bundleUrl}
        tag="a"
        type="primary">
        {buttonText || t('expore_other_product')}
      </Button>
    </div>
  );
};
export default function Empty(props: Props) {
  const {
    className,
    children,
    image,
    imageNode,
    mainDesc,
    subDesc,
    buttonLink,
    buttonText,
    bundleUrl,
    subDescStyle,
    btnStyle,
    imgClassName = '',
    testId = 'empty-module'
  } = props;
  return (
    <div
      data-testid={testId}
      className={twMerge('h-full w-full flex flex-col justify-start items-center pt-9', className)}
      style={{ minHeight: 320 }}>
      {imageNode || <img className={twMerge('w-40 mb-10', imgClassName)} src={image || foodImage} alt="empty image" />}
      {children || (
        <DefaultChildren
          bundleUrl={bundleUrl}
          mainDesc={mainDesc}
          subDesc={subDesc}
          buttonLink={buttonLink}
          buttonText={buttonText}
          subDescStyle={subDescStyle}
          btnStyle={btnStyle}
        />
      )}
    </div>
  );
}
